
export enum CustomerOPEEnum {
  PutCustomer = 'putCustomer',
  GetCustomers = 'getCustomers',
  GetAllCustomers = 'getAllCustomers',
  DelCustomer = 'delCustomer',
  ChangeCustomerOwner = 'changeCustomerOwner'
}
